"use strict";

/**
 * yandex-links.info.js — загрузка имени и превью файлов с Yandex Disk.
 */

setInterval(function () {
    let items = jQuery(".yandex-links-load-info");
    if (items.length === 0) return;

    items.each(function () {
        let el = jQuery(this);
        el.removeClass("yandex-links-load-info");

        let url = el.data("url");
        if (!url) return;

        jQuery.get("/component/yandex-disk-files/info", { url: url })
            .done(function (data) {
                if (data.name) {
                    el.find(".yandex-link-name").text(data.name);
                }
                if (data.preview) {
                    el.find(".yandex-link-thumb").attr("referrerpolicy", "no-referrer").attr("src", data.preview).css("display", "block");
                    el.find(".yandex-link-icon").hide();
                }
            });
    });
}, 200);
